import React, { forwardRef } from 'react';
import { DragHandleButton } from 'shared/components/ui/drag-handle-button';
import { useSortableDragHandle } from 'shared/hooks/use-sortable-drag-handle';
import { DataType } from 'shared/types/data-type';
import { ID } from 'shared/types/id';

import * as Styled from './sub-task-card.style';

export type SortableSubTaskRowProps = {
  id: ID;
  children: React.ReactNode;
  // Rendered outside the row so clicks inside the (portalled) menu don't bubble into the row's onClick.
  contextMenu?: React.ReactNode;
  dataComponentType?: DataType;
  onClick?: () => void;
  onContextMenu: (e: React.MouseEvent) => void;
  isSelected?: boolean;
  isDisabled?: boolean;
  isContextMenuOpen?: boolean;
};

export const SortableSubTaskRow = forwardRef<
  HTMLDivElement,
  SortableSubTaskRowProps
>(
  (
    {
      id,
      children,
      contextMenu,
      dataComponentType,
      onClick,
      onContextMenu,
      isSelected,
      isDisabled,
      isContextMenuOpen,
    },
    ref,
  ) => {
    const { containerProps, handleProps, isDragging } =
      useSortableDragHandle(id);

    return (
      <Styled.SortableContainer
        {...containerProps}
        role="presentation"
        $isDragging={isDragging}
      >
        <Styled.Container
          ref={ref}
          data-component-type={dataComponentType}
          onClick={onClick}
          onContextMenu={onContextMenu}
          $isSelected={!!isSelected}
          $isDisabled={!!isDisabled}
          $isContextMenuOpen={!!isContextMenuOpen}
        >
          {children}

          <Styled.DragHandleContainer>
            <DragHandleButton {...handleProps} />
          </Styled.DragHandleContainer>
        </Styled.Container>

        {contextMenu}
      </Styled.SortableContainer>
    );
  },
);
